import "./MoreTagsButton.scss";

import ICON from "components/icons/moreIcon.svg";

export const MoreTagsButton = (props: {
  onClick: () => void;
}): JSX.Element => {
  return (
    <button className="more moreTags" onClick={props.onClick}>
      <img src={ICON} alt="" />
    </button>
  );
};
